<button
  mat-menu-item
  [tiptool]="item.label"
  [placement]="tooltipPlacement ? tooltipPlacement : 'right'"
  [disableTooltips]="disableTooltips"
  *ngFor="let item of menu; last as isLast"
  [routerLink]="item.link"
  [ngStyle]="{ color: theme?.primaryColor }"
  (click)="clickOnItem(item.action)">
  <span *ngIf="item.icon">
    <mat-icon>{{ item.icon }}</mat-icon>
  </span>
  {{ item.label }}
</button>
